import { useTranslation } from "react-i18next";

/**
 * Enhanced translation hook that provides i18n translation + current language from loader
 *
 * Usage:
 * const { t, i18n } = useAppTranslation();
 *
 * t('Property') // For translations
 */
export function useAppTranslation() {
  const { t, i18n } = useTranslation();

  return {
    t,
    i18n,
  };
}
